import styled from 'styled-components'
import breakpoints from 'styles/breakpoints'

export const Login = styled.section`
  display: flex;
  height: 100vh;
  @media (max-width: ${breakpoints.mobile}) {
    flex-direction: column;
  }
`

export const Image = styled.div`
  background-image: url('/edificio.jpg');
  background-repeat: no-repeat;
  background-position: left center;
  background-size: auto 100%;
  flex: 2;
  @media (max-width: ${breakpoints.mobile}) {
    display: none;
  }
`

export const MobileLogo = styled.img`
  display: none;
  @media (max-width: ${breakpoints.mobile}) {
    display: block;
    width: 120px;
    margin-bottom: 32px;
  }
`

export const Form = styled.div`
  flex: 1;
  padding: 15px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: var(--color-sidebar);
  width: 100%;
  color: var(--color-white);
  & img {
    width: 150px;
    margin: 40px;
  }
  & h1 {
    text-align: start;
    width: 100%;
    padding: 0 15px;
    font-size: 32px;
  }
  & form {
    width: inherit;
    padding: 15px;
  }
  & button {
    width: 100%;
    margin: 32px 0;
  }
  & a {
    text-decoration: none;
    color: var(--color-blue);
    font-size: 18px;
  }
`
